import React from 'react';
import { Box, BoxProps, Text } from '@chakra-ui/react';

export interface OverlayHeaderProps extends BoxProps {
  headerText: string;
  subheaderText?: string;
}
export const OverlayHeader: React.FC<OverlayHeaderProps> = ({
  headerText,
  subheaderText,
  ...props
}) => (
  <Box textAlign="center" marginBottom={6} {...props}>
    <Text as="h2" fontSize="lg" fontWeight={500} data-testid="page-title">
      {headerText}
    </Text>
    {subheaderText && (
      <Text
        data-testid="page-subtitle"
        color="M.60"
        fontSize="xs"
        lineHeight="small"
        fontWeight={400}
        marginTop={1}
      >
        {subheaderText}
      </Text>
    )}
  </Box>
);
